const audio = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M3.4 6.4H0v11.2h3.4l9.2 5.6V.8z"/>
        <path fill-rule="evenodd" d="M19.5 2.1c2.8 2.4 4.5 6 4.5 9.9 0 3.9-1.7 7.5-4.5 9.9l-.9-.9c2.6-2.1 4.2-5.4 4.2-9s-1.6-6.9-4.2-9l.9-.9z" clip-rule="evenodd"/>
        <path fill-rule="evenodd" d="M15.7 5.6c1.8 1.5 3 3.8 3 6.4s-1.1 4.9-3 6.4l-.8-.8c1.6-1.3 2.6-3.3 2.6-5.5s-1-4.2-2.6-5.5c-.1-.1.8-1 .8-1z" clip-rule="evenodd"/>
    </svg>
`

export default audio
